export const osStandardFilterFields = ['organizationId', 'materialCategoryId', 'name'] as const;

export const osDateFilterFields = ['createdAt', 'updatedAt'] as const;

export const filterFields = [...osStandardFilterFields, ...osDateFilterFields] as const;
